import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-legal-notes',
  templateUrl: './legal-notes.component.html',
  styleUrls: ['./legal-notes.component.css']
})
export class LegalNotesComponent {

}
